import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'kt-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss'],
  standalone: false,
})
export class BackButtonComponent {
  @Input() previousUrl: string;

  constructor(
    private readonly router: Router,
    private readonly location: Location,
  ) {}

  goBack() {
    if (this.previousUrl.includes('/shipment-details/')) {
      this.location.back();
    } else if (this.previousUrl === window.location.pathname) {
      window.location.reload();
    } else {
      this.router.navigate([this.previousUrl]);
    }
  }
}
